













































































































































/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
// import { Component, Vue } from "vue-property-decorator";
import { Component, Vue, Watch } from "vue-property-decorator";
/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
import ButtonInspect from "@/components/common/button/ButtonInspect.vue";
import requestService from "@/service/requestService";
import {
  Buhin,
  BuhinCategory,
  SubBuhinCategory,
  BuhinDetail
} from "@/model/Buhin";
import Number from "@/shared/filters/Number";
import { Getter, Action } from "vuex-class";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import * as util from "@/service/util";
import { MESSAGE } from "@/model/Message";
import InputNumber from "@/components/common/input/InputNumber.vue";
import InputString from "@/components/common/input/InputString.vue";
import { inspectService } from "@/service/inspectService";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import WorkAndBuhin from "@/components/WorkAndBuhin.vue";
import { InspectDescriptions } from "@/model/InspectGensha";
import { Work } from "@/model/Work";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { InspectRecommendSubItem } from "@/model/InspectRecommend";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
import ButtonInspectGroup from "@/components/common/button/ButtonInspectGroup.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { INSPECT_VALUE_VIEW_TYPE } from "@/model/InspectValueViewType";

@Component({
  filters: {
    Number
  },
  components: {
    ButtonInspect,
    SaveDialog,
    ConfirmDialog,
    InputString,
    InputNumber,
    WorkAndBuhin,
    ButtonInspectGroup
  }
})
export default class PartSelection extends Vue {
  reqService: requestService;
  inspectList: InspectDescriptions[] = [];
  // seibiList: any = [];
  buhinList: Buhin[] = [];
  activeTab1: number = 0;
  activeTab2: number = 0;
  buhinCategory: BuhinCategory[] = [];
  buhinContent: any[] = [];
  oldBuhinContent: any[] = [];
  selFilter: any[] = [];
  Filter: any[] = [];
  arrActiveWork: string[] = [];
  activeWork: string = "";
  listBuhin: any = [];
  errorMsg: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = true;
  dialogSeibiVisible: boolean = false;
  isAdd: boolean = false;
  isManual: boolean = false;
  seibi: any = {};
  inspectService: inspectService;
  seibiEditedIndex: number = -1;
  activeInspect: any = {};
  activeInspectId: number = -1;
  listRecommend: any = [];
  listInspectByResult: InspectDescriptions[][] = [];
  isInspect: boolean = false;
  msgAskMD15: string = MESSAGE.AskMD15;
  displayDialogEdit: boolean = false;
  editTitle: string = "";
  editItem: any = {};
  hideTriangle: boolean = false;
  // 2022-01-31 morisako kobac-free add [START]
  freeOfChargeNm: string = '無償対応';
  // 2022-01-31 morisako kobac-free add [END]

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("katashiki", { namespace: "CarSelection" })
  katashiki: string;

  @Getter("engineKatashiki", { namespace: "CarSelection" })
  engineKatashiki: string;

  // 2022-01-31 morisako kobac-free add [START]
  @Action("remove", { namespace: "SeibiIds" })
  removeSeibiId: any;
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Getter("seibiMenuCd", { namespace: "InspectionDetail" })
  seibiMenuCd: string;
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  $refs!: {
    errorDialog: ConfirmDialog;
    saveDialog: SaveDialog;
    inputManualSeibi: InputString;
    workBuhinRef: WorkAndBuhin;
    confirmDialog: ConfirmDialog;
    cancelDialog: ConfirmDialog;
  };

  activeFirstInspect(listInspect: any) {
    if (listInspect.length > 0 && listInspect[0].length > 0) {
      this.onClickInspect(listInspect[0][0]);
    } else if (listInspect.length > 0 && listInspect[1].length > 0) {
      this.onClickInspect(listInspect[1][0]);
    } else {
      const allNoItem = this.listRecommend.every(
        (e: any) => e.subItems.length == 0
      );
      if (!allNoItem) {
        this.listRecommend[0].seibiList = this.listRecommend[0].subItems;
        this.activeInspectId = this.listRecommend[0].sknRecommendInspectCategoryId
        this.$set(this, "activeInspect", this.listRecommend[0]);
        this.$refs.workBuhinRef.onSelectWork(
          this.listRecommend[0].seibiList[0],
          0,
          false,
          true
        );
      } else {
        this.$set(this, "activeInspect", {});
        this.$refs.workBuhinRef.resetBuhin();
        this.$forceUpdate();
      }
    }
  }

  initData(res: any, first: boolean = false) {
    if (res && res.inspectList) {
      this.inspectList = res.inspectList;
      this.listRecommend = res.recommend;
      const _listInspect = this.inspectService.getinspectListByResult(
        this.inspectList
      );

      this.$set(this, "listInspectByResult", _listInspect);

      if (this.inspectList.length == 0 && this.listRecommend.length == 0) {
        this.$refs.workBuhinRef.hideBuhin();
      } else {
        const allNoItem = this.listRecommend.every(
          (e: any) => e.subItems.length == 0
        );
        let noInspect = false;
        if (this.inspectList.length == 0) {
          noInspect = true;
        } else {
          noInspect = this.inspectList.every(
            (e: any) => e.inspectResult == InspectButtonValue.CIRCLE
          );
        }
        if (noInspect && allNoItem) {
          this.$refs.workBuhinRef.hideBuhin();
        }
      }
      if (first) {
        this.activeFirstInspect(_listInspect);
      } else {
        let found: any = null;
        if (this.activeInspectId > -1) {
          if (this.isInspect) {
            found = this.inspectList.find(
              inspect => inspect.sknInspectDescriptionId == this.activeInspectId
            );
          } else {
            found = this.listRecommend.find(
              (item: any) =>
                item.sknRecommendInspectCategoryId == this.activeInspectId
            );
          }
        }
        if (found) {
          if (!this.isInspect) {
            found.seibiList = found.subItems;
          }
          this.$set(this, "activeInspect", found);
          this.$refs.workBuhinRef.reInitBuhin(found);
        } else {
          this.activeFirstInspect(_listInspect);
        }
      }
    }
  }

  created() {
    this.$emit("onactivepage", this.$route.name);
    this.reqService = new requestService();
    this.inspectService = new inspectService();
    this.loading = true;
    this.getData(true);
    // 2022-01-31 morisako kobac-free add [START]
    this.getFreeOfChargeNm();
    // 2022-01-31 morisako kobac-free add [END]
  }

  getData(isFirst: boolean = false) {
    this.reqService.getPartSelection(this.uketsukeExtendsId).then(
      (res: any) => {
        this.loading = false;
        this.initData(res, isFirst);
      },
      (err: any) => {
        this.loading = false;
        this.onError(err);
      }
    );
  }

  onClickInspect(inspect: any) {
    this.isInspect = true;
    this.activeInspect = inspect;
    this.activeInspectId = inspect.sknInspectDescriptionId;
    if (inspect.seibiList.length > 0) {
      let index = inspect.seibiList.findIndex(
        (seibi: Work) => seibi.buhinSelected != STATUS_SELECT_WORK_BUHIN.Initial
      );
      if (index == -1) {
        index = 0;
      }
      this.$refs.workBuhinRef.onSelectWork(
        inspect.seibiList[index],
        index,
        false,
        true
      );
    } else if (inspect.manualSeibiList.length > 0) {
      this.$refs.workBuhinRef.onSelectWork(
        inspect.manualSeibiList[0],
        0,
        true,
        true
      );
    } else {
      this.$refs.workBuhinRef.onNoSeibi();
    }
  }

  onClickReccomend(recCate: any, index: number) {
    this.isInspect = false;
    let sknInspectDescriptionId = index + 900;
    const seibiList = recCate.subItems;
    const inspect: any = {
      seibiList
    };
    this.activeInspectId = recCate.sknRecommendInspectCategoryId;
    this.activeInspect = inspect;
    if (inspect.seibiList.length > 0) {
      this.$refs.workBuhinRef.onSelectWork(
        inspect.seibiList[0],
        0,
        false,
        true
      );
    }
  }

  isActiveInspect(inspect: any) {
    if (inspect.sknInspectDescriptionId && this.isInspect)
      return this.activeInspectId == inspect.sknInspectDescriptionId;
    if (inspect.sknRecommendInspectCategoryId && !this.isInspect)
      return this.activeInspectId == inspect.sknRecommendInspectCategoryId;
  }

  onRegister() {
    const status = this.inspectService.getRegisterStatusMD15(this.inspectList);
    if (status == NAVIGATION_STATUS.REGISTER_NOTCOMPLETE) {
      this.$refs.confirmDialog.onOpen();
    } else {
      this.$emit("saveSpentTime", true);
      this.$emit("onregister", { pageName: this.$route.name, status });
    }
  }

  onSave() {
    this.$emit("saveSpentTime");
    this.$refs.saveDialog.onOpen();
  }

  // saveData() {
  //   this.loading = true;
  //   const data = {
  //     sknUketsukeExtendsId: this.uketsukeExtendsId,
  //     items: this.seibiList,
  //     manualItems: this.manualList
  //   };
  //   this.seibiList.forEach((seibi: any) => {
  //     seibi.items = seibi.items.map((item: any) => {
  //       delete item.showWork;
  //       return item;
  //     });
  //   });
  //   return this.reqService.savePartSelection(data);
  // }

  saveInspectItem(inspectItem: InspectDescriptions, changeList: any) {
    if (this.isInspect) {
      let objForSave = JSON.parse(JSON.stringify(inspectItem));
      delete objForSave.status;
      delete objForSave.showWork;
      if (changeList) {
        objForSave.changeList = changeList;
      }
      objForSave.seibiList.forEach((seibi: Work) => {
        if (seibi.disabledSave) {
          delete seibi.disabledSave;
        }
      });
      //部品選択側からの保存動作なので、ローディングと完了メッセージはこちらで動かす
      this.loading = true;
      this.reqService.savePartSelection(objForSave).then(
        (res: any) => {
          this.loading = false;
          if (res.status == 200 && res.body) {
            this.initData(res.body);
          }
          this.$refs.workBuhinRef.showMsgConfirm();
        },
        error => {
          this.loading = false;
          console.error("error", error);
          this.$notify.error({
            title: "エラー",
            message: inspectItem.sknInspectDescriptionNm
          });
        }
      );
    }
  }

  onError(res: any) {
    this.loading = false;
    this.errorMsg = util.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  inspectResClass(index: number) {
    return this.inspectService.inspectResClassTitle(index);
  }

  onConfirmBuhin(data: { inspectItem: InspectDescriptions; seibi: any, changeList: any }) {
    if (
      data.seibi.sknInspectType == INSPECT_TYPE.RECOMMEND ||
      data.seibi.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL
    ) {
      this.editItem = data.seibi;
      this.onSaveInspectResult(data.changeList, true);
    } else {
      this.saveInspectItem(data.inspectItem, data.changeList);
    }
  }

  onCallbackDeleteManualSeibi(sknUketsukeInspectId: any) {
    if(sknUketsukeInspectId) {
      this.reqService.sendSocket(
        this.uketsukeExtendsId,
        sknUketsukeInspectId
      );
    }
  }

  callbackDeleteBuhin(data: any) {
    this.editItem = data.data;
    if (this.editItem.hasOwnProperty("changeList")) {
      delete this.editItem.changeList;
    }
    this.onSaveInspectResult();
  }

  inspectSuccess(inspect: InspectDescriptions) {
    if (
      inspect.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Done ||
      inspect.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.NoNeed
    ) {
      return true;
    }
    return false;
  }

  seibiRecSuccess(index: number) {
    const seibiNobuhin = this.listRecommend[index].subItems.filter(
      (seibi: any) => seibi.buhinSelected == 0
    );
    if (seibiNobuhin.length > 0) {
      return false;
    }
    return true;
  }

  showTitle(index: number) {
    if (this.listInspectByResult[index].length > 0) {
      return true;
    }
    return false;
  }

  onConfirmSave() {
    this.$emit("saveSpentTime", true);
    this.$emit("onregister", {
      pageName: this.$route.name,
      status: NAVIGATION_STATUS.REGISTER_NOTCOMPLETE
    });
  }

  showDialogEdit(event: any, item: any) {
    event.stopPropagation();
    this.onEditResult(item);
  }

  onEditResult(item: any) {
    this.editTitle =
      item.sknInspectDescriptionNm || item.sknRecommendInspecSeibiNm;
    this.displayDialogEdit = true;
    this.editItem = util.deepCopy(item);
    if (item.sknInspectType != 2 && item.sknInspectType !=4) {
      this.hideTriangle = this.isNoSeibi(this.editItem);
    } else {
      this.hideTriangle = false;
    }
  }

  onInspectBtnChange(result: number) {
    if (
      this.editItem.sknInspectType == INSPECT_TYPE.RECOMMEND ||
      this.editItem.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL
    ) {
      this.editItem.osusumeIsShow = result;
    } else {
    this.editItem.inspectResult = result;
    if (result === InspectButtonValue.CIRCLE) {
      this.editItem.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      // 2022-01-31 morisako kobac-free add [START]
      let objForSave: InspectDescriptions = this.removeInspectParam(this.editItem);
      this.editItem = util.deepCopy(objForSave);
      // 2022-01-31 morisako kobac-free add [END]
    }
    }
  }

  onSaveInspectResult(changeList: any = null, isWorkBuhin: boolean = false) {
    this.displayDialogEdit = false;
    let sendSocket = false;
    let isSocket = 0;
    let path = "gensha";
    let data: any = {};
    if (this.editItem.seibiList && this.editItem.seibiList.length > 0) {
      this.editItem.seibiList.forEach((item: any) => {
        delete item.inspectResult;
        item.buhinList.forEach((buhin: any) => {
          delete buhin.kousuu;
        });
      });
    }
    if (
      this.editItem.sknInspectType == INSPECT_TYPE.RECOMMEND ||
      this.editItem.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL
    ) {
      if (this.editItem.buhinSelected > 0 || this.editItem.inspectResult == 1) {
        isSocket = 1;
      }
      if (this.editItem.osusumeId == null && this.editItem.sknInspectSeibiDetailId == null) {
      let item = {
        sknUketsukeExtendsId: this.uketsukeExtendsId + ''
        , seibiId: this.editItem.sknRecommendInspecSeibiId
        , seibiNm: this.editItem.sknRecommendInspecSeibiNm
        , buhinList: this.editItem.buhinList
        , kouchinZn: this.editItem.kouchinZn
        , buhinSelected: (typeof this.editItem.buhinSelected !== "undefined") ? (this.editItem.osusumeIsShow == 0 ? STATUS_SELECT_WORK_BUHIN.delete: this.editItem.buhinSelected) : STATUS_SELECT_WORK_BUHIN.Done // 2021-07-06 sh edit #7357
        , sknInspectType: INSPECT_TYPE.RECOMMEND_MANUAL
        , sknRecommendInspectCategoryId: this.editItem.sknRecommendInspectCategoryId
        , osusumeIsShow: (typeof this.editItem.osusumeIsShow !== "undefined") ? this.editItem.osusumeIsShow: 1
      }
      data = {
        recommend: [
          {
            manualItems: [item]
          }
        ]
      };
      } else {
        /** 2021-07-06 sh #7257 it does not work that change teian-suru to shinai.(MD-0015) [START] */
      // data = {
      //  recommend: [
      //    {
      //      subItems: [this.editItem]
      //    }
      //  ]
      //};
        let saveItem = util.deepCopy(this.editItem);
        saveItem.buhinSelected = this.editItem.osusumeIsShow == 0 ? STATUS_SELECT_WORK_BUHIN.Initial : this.editItem.buhinSelected;
        /** 2022-10-14 sh #8093(BQR1055) delete "isSelected" from json. [START] */
        if (saveItem.osusumeBuhinList && saveItem.osusumeBuhinList.length > 0) {
          saveItem.osusumeBuhinList.forEach((item: any) => {
            if (item.hasOwnProperty("isSelected")) {
              delete item.isSelected;
            }
          });
        }
        /** 2022-10-14 sh #8093(BQR1055) delete "isSelected" from json. [END] */
        data = {
          recommend: [
            {
              subItems: [saveItem]
            }
          ]
        };
        /** 2021-07-06 sh #7257 it does not work that change teian-suru to shinai.(MD-0015) [END] */
      }
      data.isSocket = isSocket;
      if (changeList) {
        data.changeList = changeList;
      }
    } else {
      sendSocket = true;
      if (this.editItem.hasOwnProperty("changeList")) {
        delete this.editItem.changeList;
      }
      if (this.editItem.inspectResult == InspectButtonValue.CIRCLE) {
        this.activeInspectId = -1;
      }
      if (this.inspectSuccess(this.editItem)) {
        isSocket = 1;
      }
      if (this.editItem.sknInspectType == INSPECT_TYPE.LEGAL56) {
        path = "legal56";
        data.isSocket = isSocket;
      } else if (this.editItem.sknInspectType == INSPECT_TYPE.INSPECT_LINE) {
        path = "inspectLine";
      } else {
        data.isSocket = isSocket;
      }
      if (
        this.editItem.manualSeibiList &&
        this.editItem.manualSeibiList.length > 0
      ) {
        const listFiltered = this.editItem.manualSeibiList.filter(
          (seibi: Work) => seibi.buhinSelected > 0
        );
        if (listFiltered.length > 0) {
          this.editItem.manualSeibiList = listFiltered;
        }
      }
      data[path] = [
        {
          subItems: [
            {
              inspectDescriptions: [this.editItem]
            }
          ]
        }
      ];
    }

    let req = null;
    //部品選択側からの保存指示の場合、ローディングと完了メッセージはこちらで動かす
    if(isWorkBuhin) this.loading = true;
    if (this.editItem.sknInspectType == INSPECT_TYPE.INSPECT_LINE) {
      //md-5
      req = this.reqService.saveInspectLineSeibi(data);
    } else if (
      this.editItem.sknInspectType == INSPECT_TYPE.RECOMMEND ||
      this.editItem.sknInspectType == INSPECT_TYPE.RECOMMEND_MANUAL
    ) {
      //md-8
      req = this.reqService.saveInspectRecommend(data);
    } else {
      //md-4, 6
      req = this.reqService.saveInspect(data, path);
    }

    if (req) {
      req.then(
        (res: any) => {
          if (res.status == 200) {
            if (isSocket && sendSocket) {
              this.reqService.sendSocket(
                this.uketsukeExtendsId,
                this.editItem.sknUketsukeInspectId
              );
            }
            this.getData();
            if(isWorkBuhin) this.$refs.workBuhinRef.showMsgConfirm();
          }
        },
        error => {
          const nm =
            this.editItem.sknInspectDescriptionNm ||
            this.editItem.sknRecommendInspecSeibiNm;
          this.$notify.error({
            title: "エラー",
            message: nm
          });
        }
      );
      if(isWorkBuhin) this.loading = false;
    }else{
      if(isWorkBuhin) this.loading = false;
    }
  }

  get recommendLength() {
    const list = this.listRecommend.filter((item: any) => item.subItems.length > 0);
    return list.length;
  }

  isNoSeibi(inspect: InspectDescriptions) {
    if (
      inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BASIC_OBD ||
      inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SYNC_OBD
    ) {
      return true;
    }
    return this.inspectService.isNoSeibi(inspect);
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      this.$router.push({ name: "reservation" });
    });
  }

  // 2022-01-31 morisako kobac-free add [START]
  getFreeOfChargeNm() {
    this.reqService.getMSknFreeOfCharge(this.uketsukeExtendsId)
    .then((res: any) => {
      if (res.freeOfChargeNm) this.freeOfChargeNm = res.freeOfChargeNm;
    });
  }
  removeInspectParam(inspectItem: InspectDescriptions, copy: boolean = true) {
    let objForSave = {} as InspectDescriptions;
    if (copy) {
      objForSave = util.deepCopy(inspectItem);
    } else {
      objForSave = inspectItem;
    }
    delete objForSave.status;
    delete objForSave.showWork;
    delete objForSave.showValue;
    delete objForSave.isSaving;
    if (objForSave.inspectResult == InspectButtonValue.CIRCLE) {
      let oldWorkBuhinSelected = objForSave.workBuhinSelected;
      objForSave.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      if (oldWorkBuhinSelected == 0) {
        objForSave.seibiList = [];
      } else {
        if (objForSave.manualSeibiList.length > 0) {
          const manualSeibiList = util.deepCopy(objForSave.manualSeibiList);
          objForSave.manualSeibiList = [];
          manualSeibiList.forEach((seibi: any) => {
            const id: any = seibi.seibiId;
            this.reqService.deleteManualSeibi({
              sknUketsukeManualSeibiId: id,
              uketsukeExtendsId: this.uketsukeExtendsId
            });
            return seibi;
          });
        }
        objForSave.seibiList.forEach((seibi: Work) => {
          const buhinSelected = seibi.buhinSelected;
          seibi.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
          if (seibi.manualBuhinList.length > 0) {
            seibi.manualBuhinList.forEach(buhin => {
              if (buhin.buhinId) {
                this.reqService.deleteManualBuhin(buhin.buhinId);
              }
            });
          }
          if (seibi.buhinList.length > 0) {
            seibi.buhinList.forEach(buhin => {
              if (buhin.id) {
                buhin.isDelete = 1;
              }
            });
          }
        });
      }
    }

    if (objForSave.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.FakeDone) {
       objForSave.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
     }
    for (let i = objForSave.seibiList.length - 1; i >= 0; i--) {
      if (
        objForSave.seibiList[i].buhinSelected ==
          STATUS_SELECT_WORK_BUHIN.Initial &&
        objForSave.seibiList[i].seibiId == null
      ) {

        objForSave.seibiList.splice(i, 1);
      } else {
        if (objForSave.seibiList[i].disabledSave) {
          if (objForSave.sknUketsukeInspectId == null && objForSave.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Done) {
            if (objForSave.seibiList[i].sknInspectType == INSPECT_TYPE.GENSHA || objForSave.seibiList[i].sknInspectType == INSPECT_TYPE.LEGAL56) {
              objForSave.seibiList.splice(i, 1);
            } else {
              delete objForSave.seibiList[i].disabledSave;
            }
          } else {
            objForSave.seibiList.splice(i, 1);
          }
        } else {
          const buhinList = objForSave.seibiList[i].buhinList.filter(
            buhin => buhin.quantity > 0
          );
          objForSave.seibiList[i].buhinList = buhinList;
          if (objForSave.seibiList[i].hasOwnProperty("disabledSave")) {
            delete objForSave.seibiList[i].disabledSave;
          }
          if (objForSave.seibiList[i].hasOwnProperty("ignoreSeibi")) {
            delete objForSave.seibiList[i].ignoreSeibi;
          }
        }
      }
    }
    return objForSave;
  }
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Watch("seibiMenuCd")
  reInitData() {
    this.loading = true;
    this.getData();
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
}
